<template>
    <v-card class="users-list">
        <v-card-title>
            <v-row v-if="clientData && clientData.name" align="center">
                <div v-bind:style="{ backgroundColor: clientData.avatarsColors[clientData.index % clientData.avatarsColors.length]}"
                     class="px-6 mx-6 my-0 users-list__client-avatar">{{clientData.name[0]}}
                </div>
                <h2 class="px-2 my-0">{{clientData.name}}</h2>
                <v-btn @click="deleteClient" text>
                    <v-icon color="primary">delete</v-icon>
                </v-btn>
            </v-row>
            <v-spacer></v-spacer>
            <v-text-field
                    class="col-4"
                    v-model="search"
                    append-icon="search"
                    label="Search"
                    single-line
                    hide-details
            ></v-text-field>
        </v-card-title>
        <v-data-table
                :headers="headers"
                :items="users"
                :search="search"
        ></v-data-table>
    </v-card>
</template>

<script>
    import axios from 'axios'

    export default {
        name: "UsersList",
        props: ['users', 'headers', 'search'],
        data: () => ({
            clientData: null
        }),
        mounted() {
            this.clientData = this.$route.params;
        },
        methods: {
            deleteClient: function () {
                axios.delete(`/domains/${this.clientData.id}`).then(resp => {
                    this.$router.push({name: 'Clients'})
                })
            }
        }
    }
</script>

<style scoped>

</style>
